"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      position: 'relative'
    },
    containerClosed: {
      display: 'none'
    },
    closeIcon: {
      cursor: 'pointer'
    },
    callout: {
      fontSize: 14,
      borderRadius: 2,
      outline: 'transparent'
    },
    beak: {
      position: 'absolute',
      backgroundColor: theme.palette.NEUTRAL500,
      boxShadow: 'inherit',
      transform: 'rotate(45deg)',
      height: 16,
      width: 16,
      border: 'inherit',
      left: 57,
      top: -8
    },
    main: {
      backgroundColor: 'rgb(255, 255, 255)',
      overflowX: 'hidden',
      overflowY: 'auto',
      position: 'relative',
      borderRadius: 2,
      outline: 'none'
    },
    header: {
      padding: theme.spacing(1.5, 1.6),
      borderRadius: '4px 4px 0 0',
      color: theme.palette.NEUTRAL000,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: theme.palette.NEUTRAL500
    },
    headerInfo: {
      backgroundColor: theme.palette.BLUE400
    },
    headerSuccess: {
      backgroundColor: theme.palette.GREEN400
    },
    headerDanger: {
      backgroundColor: theme.palette.RED400
    },
    headerWarning: {
      color: theme.palette.NEUTRAL700,
      backgroundColor: theme.palette.YELLOW200
    },
    headerAction: {
      display: 'flex',
      alignItems: 'center'
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    title: {
      fontSize: 16
    },
    titleIcon: {
      marginRight: theme.spacing(2),
      display: 'flex'
    },
    content: {
      height: '100%',
      padding: theme.spacing(2),
      borderRadius: '0 0 4px 4px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      backgroundColor: theme.palette.NEUTRAL030
    },
    contentInfo: {
      backgroundColor: theme.palette.BLUE050
    },
    contentSuccess: {
      backgroundColor: theme.palette.GREEN050
    },
    contentDanger: {
      backgroundColor: theme.palette.RED050
    },
    contentWarning: {
      color: theme.palette.NEUTRAL700,
      backgroundColor: theme.palette.YELLOW050
    }
  };
});
var _default = useStyles;
exports.default = _default;